<fieldset>
    <legend>Profile Settings</legend>
    <div class="row">
        <div class="col-4" *ngIf="showEcontract">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [label]="'E-Contract on File'" [disabled]="econtractDisable"
                    [options]="eContractOnFile" [selectedValue]="viewUserProfile.AttestationAccepted"
                    (onValueChange)="viewUserProfile.AttestationAccepted=$event">
                </ValidatedDropDown>
            </div>
        </div>
        <div class="col-7">
            <div class="input-wrapper">
                <label>Commission Level</label>
                <ValidatedDropDown class="wide" [disabled]="'false'" [options]="commissionLevel"
                    (onValueChange)="viewUserProfile.CommissionLevel=$event"
                    [selectedValue]="viewUserProfile.CommissionLevel">
                </ValidatedDropDown>
            </div>
        </div>

        <div class="col-7">
            <div class="input-wrapper">
                <label>Agreement Version Number</label>
                <ValidatedTextField class="" [text]="viewUserProfile.AgreementVersionNumber"
                    (onValueChange)="viewUserProfile.AgreementVersionNumber= $event" maxlength="10">
                </ValidatedTextField>
            </div>
        </div>


    </div>
    <div class="row" *ngIf="showEcontract">
        <div class="col-16">
            <div class="detail-info">
                <div> {{ attestedDetails }}</div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-7">
            <div class="input-wrapper">
                <label>NPN <span *ngIf="!isRequired"><strong>(optional)</strong></span></label>
                <ValidatedTextField class="field" id="niprnum" [text]="viewUserProfile.NIPR"
                    (onValueChange)="viewUserProfile.NIPR = $event" maxlength="10"></ValidatedTextField>
            </div>
        </div>
        <div class="col-5">
            <div class="input-wrapper">
                <ValidatedDropDown class="wide" [label]="'Text Message Opt In'" [disabled]="'false'"
                    [options]="textMsgOptIn" [selectedValue]="viewUserProfile.TextMessageOptIn"
                    (onValueChange)="viewUserProfile.TextMessageOptIn=$event">
                </ValidatedDropDown>
            </div>
        </div>


    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-10">
                <ValidatedCheckbox [id]="'change-password'" [label]="'Change Password'"
                    [checked]="viewUserProfile.ChangePassword" (onValueChange)="viewUserProfile.ChangePassword= $event">
                </ValidatedCheckbox>
            </div>
        </div>
    </div>
    @if (screenMode === 'edit' && !isAdminUpdate) {
    <div class="row" id="divEditUser">
        <div class="col-16">
            <div class="bottom-10">
                <ValidatedCheckbox [id]="'change-email'" [label]="'Change Email'"
                    [checked]="viewUserProfile.ChangeEmail" (onValueChange)="viewUserProfile.ChangeEmail= $event">
                </ValidatedCheckbox>
            </div>
        </div>
        <div class="col-16">
            <div class="bottom-10">
                <ValidatedCheckbox [id]="'change-cell-phone-number'" [label]="'Change Cell Phone Number'"
                    [checked]="viewUserProfile.ChangeCellPhoneNumber"
                    (onValueChange)="viewUserProfile.ChangeCellPhoneNumber= $event">
                </ValidatedCheckbox>
            </div>
        </div>
        <!--<div class="col-16">
                <div class="bottom-10">
                    <ValidatedCheckbox [id]="'Opt-in-to-Silver-Mail-notifications'"
                                       [label]="'Opt-in to Silver Mail Notifications'"
                                       [checked]="viewUserProfile.SilverMailOptIn"
                                       (onValueChange)="viewUserProfile.SilverMailOptIn= $event">
                    </ValidatedCheckbox>
                </div>
            </div>-->
    </div>
    }
    <div class="row">
        @if (screenMode === 'edit' && !isAdminUpdate) {
        <div class="col-16" id="divProfileHistory">
            <p class="bottom-10">Please allow 5 minutes for history changes to be available.</p>
            <p class="bottom-10">Profile created by {{ viewUserProfile.RecCreateUserID }} on {{
                viewUserProfile.RecCreateTSString }}.</p>
            <p class="bottom-10">Last log in: {{ viewUserProfile.LastSuccesfulLogonDateStr }}</p>
        </div>
        }
    </div>

    <div class="row">
        <div class="col-16">
            <ErrorMessages [errorMessages]="errorMessages"></ErrorMessages>
        </div>
    </div>

</fieldset>